export const createPreSignup = async (params) => {
  return fetch('/api/v1/pre_signups', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(params),
  }).then((response) => response.json());
};
